import WarningIcon from '@material-ui/icons/Warning';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import UserSettingIconCustom from '../../CustomIcons/UserSettingIconCustom.jsx';


export default class UserImpersonateEventRow extends React.Component {
  render() {
    const { event: { id, timestamp, actorId, data: { actor, entity } }, isAnonymized, privateUnitIdActor } = this.props;
    const isReadOnly = entity && entity.email && _.includes(entity.email, 'readonly');
    return (
      <div style={{ minHeight: 110, padding: 15, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <UserSettingIconCustom style={{ width: 30, marginRight: 30, color: '#3f3f3f' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ color: '#3f3f3f', fontWeight: 'bold', margin: 0 }}>
              <Entity key={id} entity="userImpersonate" />
            </h3>
            <h4 style={{ color: '#3f3f3f', lineHeight: '1.5em', fontWeight: '100', margin: 0, marginTop: 10 }}>
              {isAnonymized ? (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <WarningIcon style={{ color: 'orange', marginRight: 10, fontSize: 20 }} />
                  <h4 style={{ color: '#3f3f3f', lineHeight: '1.5em', fontWeight: '100', margin: 0 }}>
                    <Entity
                      key={id}
                      entity="adminEventRowAnonymizedDescription"
                    />
                  </h4>
                </div>
              ) : (
                <Entity
                  key={id}
                  entity={isReadOnly ? 'userImpersonateDescriptionReadOnly' : 'userImpersonateDescription'}
                  data={{
                    actor: actor && actorId ? `${actor.firstname} ${actor.lastname || ''} ${actor.email || ''}` : '---',
                    entity: entity ? `${entity.firstname} ${entity.lastname || ''} ${entity.email || ''}` : '---',
                    duration: actor && actor.impersonateDuration || 30,
                  }}
                />
              )}
            </h4>
          </div>
        </div>
        <h4 style={{ minWidth: 240, textAlign: 'right', marginTop: 10, color: '#3f3f3f' }}>{moment(timestamp).format('LLL')}</h4>
      </div>
    );
  }
}